import { forwardRef, Inject, Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CustomLabelService } from "../../service/custom-label.service";
import { LocalizationPipe } from "../../shared/pipe";

@Injectable()
export class SnackbarService {

    constructor(
        @Inject(forwardRef(() => MatSnackBar)) private snackBar: MatSnackBar,
        @Inject(forwardRef(() => LocalizationPipe)) private localizationPipe: LocalizationPipe,
        @Inject(forwardRef(() => CustomLabelService)) private labelService: CustomLabelService
    ) { }

    showSnackbar(text: string, panelClass?: string, translateText: boolean = true, actionLabel?: string): Promise<MatSnackBarRef<any>> {
        if (translateText) {
            return Promise.all([this.labelService.getCustomLabel(text), this.labelService.getCustomLabel(actionLabel || '')])
                .then(messages => this.doShowSnackbar(this.localizationPipe.transform(messages[0]), panelClass, this.localizationPipe.transform(messages[1])));
        } else {
            return Promise.resolve(this.doShowSnackbar(text, panelClass))
        }
    }

    private doShowSnackbar(message: string, panelClass: string, actionLabel?: string): MatSnackBarRef<any> {
        return this.snackBar.open(message, actionLabel, {
            duration: 6000,
            panelClass: panelClass || 'notification-info'
        });
    }
}